"use client";
import ContactForm from "../forms/contact-form";

const contactInfo = [
  {
    id: 0,
    icon: "fal fa-map-marker-alt",
    title: "Address",
    subtitle: "418 Broadway STE N, Albany, NY 12207, USA",
  },
  {
    id: 1,
    icon: "fal fa-phone-alt",
    title: "Phone",
    subtitle: "+1 (929) 305-2812",
  },
  {
    id: 2,
    icon: "fal fa-envelope",
    title: "Email",
    subtitle: "info@tashlimafamilyshop.org",
  },
];

const ContactArea = () => {
  return (
    <>
      <section className="contact__area">
        <div className="contact__wrapper">
          {/* Contact Info */}
          <div className="contact__info-wrapper">
            <h3 className="section-title">Contact Information</h3>
            <ul className="contact__info-list">
              {contactInfo.map((item) => (
                <li key={item.id} className="contact__info-item">
                  <div className="contact__icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="contact__details">
                    <h5>{item.title}</h5>
                    {item.icon.includes("phone") ? (
                      <a href={`tel:${item.subtitle}`}>{item.subtitle}</a>
                    ) : item.icon.includes("envelope") ? (
                      <a href={`mailto:${item.subtitle}`}>{item.subtitle}</a>
                    ) : (
                      <span>{item.subtitle}</span>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            <div className="contact__social">
              <h5 className="social-title">Follow us on</h5>
              <ul>
                <li className="facebook"><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                <li className="instagram"><a href="#"><i className="fab fa-instagram"></i></a></li>
                <li className="whatsapp"><a href="#"><i className="fab fa-whatsapp"></i></a></li>
                <li className="youtube"><a href="#"><i className="fab fa-youtube"></i></a></li>
              </ul>
            </div>
          </div>

          {/* Contact Form Card */}
          <div className="contact__form-card">
            <h3 className="section-title">Send us a Message</h3>
            <div className="contact__form-wrapper">
              <ContactForm />
            </div>
          </div>
        </div>

        <style jsx>{`
          .contact__area {
            padding: 60px 15px;
            background: linear-gradient(135deg, #f6f3ff, #eae6ff);
          }

          .contact__wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            max-width: 1100px;
            margin: 0 auto;
            justify-content: center;
          }

          /* Info Card */
          .contact__info-wrapper,
          .contact__form-card {
            flex: 1 1 400px;
            min-width: 280px;
            background: #fff;
            border-radius: 18px;
            padding: 20px;
            box-shadow:
              8px 8px 20px rgba(120, 90, 230, 0.2),
              -6px -6px 15px rgba(255, 255, 255, 0.3),
              inset 1px 1px 2px rgba(255, 255, 255, 0.4),
              inset -1px -1px 2px rgba(140, 110, 255, 0.2);
          }

          .section-title {
            font-size: 1.6rem;
            font-weight: 700;
            color: #7F5FD9;
            margin-bottom: 18px;
            text-align: center;
          }

          .contact__info-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .contact__info-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 10px;
            gap: 12px;
          }

          .contact__icon {
            font-size: 28px;
            color: #7f56d9;
            min-width: 36px;
            display: flex;
            align-items: center
          }

          .contact__details h5 {
            font-weight: 600;
            font-size: 18px;
            margin: 0 0 3px;
            color: #3c2b80;
          }

          .contact__details a,
          .contact__details span {
            font-size: 16px;
            color: #222;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .contact__details a:hover {
            color: #6b5bff;
          }

          .contact__social {
            margin-top: 15px;
            text-align: center;
          }

          .social-title {
            font-weight: 600;
            font-size: 15px;
            margin-bottom: 10px;
            color: #5a2dbf;
          }

          .contact__social ul {
            display: flex;
            justify-content: center;
            gap: 15px;
            padding: 0;
            list-style: none;
          }

          .contact__social ul li {
            font-size: 28px;
            transition: transform 0.2s ease, color 0.2s ease;
          }

          .contact__social ul li a {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .facebook i { color: #1877f2; }
          .instagram i { color: #e4405f; }
          .whatsapp i { color: #25d366; }
          .youtube i { color: #ff0000; }

          .contact__social ul li:hover {
            transform: scale(1.2);
          }

          /* Responsive */
          @media (max-width: 992px) {
            .contact__wrapper {
              flex-direction: column;
              align-items: center;
            }

            .contact__info-wrapper,
            .contact__form-card {
              width: 100%;
            }
          }

          @media (max-width: 576px) {
            .contact__area {
              padding: 40px 10px;
            }

            .section-title {
              font-size: 1.4rem;
            }

            .contact__social ul li {
              font-size: 20px;
            }
          }
        `}</style>
      </section>
    </>
  );
};

export default ContactArea;
